/** Item do menu lateral renderizado. `route` ausente = item não-navegável (teaser "em breve"). */
export interface NavItem {
  readonly label: string;
  readonly icon: string;
  readonly route?: string;
  readonly badge?: string;
  readonly disabled?: boolean;
}

export interface NavGroup {
  readonly title: string;
  readonly items: readonly NavItem[];
}

/**
 * Grupos ESTÁTICOS do menu — área geral disponível a qualquer autenticado, que não
 * são módulos do catálogo (sem `module:action`). Os demais grupos são montados em
 * runtime a partir do catálogo (`GET /me/menu`), ver `Shell.visibleNav()`.
 */
export const STATIC_NAV: readonly NavGroup[] = [
  {
    title: 'Geral',
    items: [
      { label: 'Visão geral', icon: '▦', route: '/visao-geral' },
      { label: 'Documentação', icon: 'ⓘ', route: '/documentacao' },
    ],
  },
];

/**
 * Rótulo e ordem de cada seção do menu. A `section` de cada módulo no catálogo é um
 * slug (ex.: `administracao`); aqui ele vira o título exibido (com acento) e ganha
 * uma ordem de exibição. Seção sem entrada cai para o fim, usando o próprio slug.
 */
export const SECTION_META: Record<string, { readonly label: string; readonly order: number }> = {
  ferramentas: { label: 'Ferramentas', order: 10 },
  clientes: { label: 'Clientes', order: 20 },
  administracao: { label: 'Administração', order: 30 },
};
